import numeral from 'numeral';
import { format, isValid } from 'date-fns';
import Config from '@/views/Reports/reportSettings';
import { locales } from '@/helpers/date-locales';
import { secondsToHumanReadable } from '@/helpers/date-helper';
import i18n from '@/i18n';
import _ from '@/setup/lodash';
import type { App } from 'vue';

function formatDate(value: string, formatStr: string) {
  return value
    ? isValid(new Date(value))
      ? format(value, formatStr, { locale: locales[i18n.global.locale.value] })
      : typeof value === 'string'
        ? value
        : ''
    : '';
}

const filters = {
  'uppercase': (value: string) => {
    let v = value;
    if (!v) return '';
    v = v.toString();
    return v.toUpperCase();
  },
  'capitalize': (value: string) => {
    let v = value;
    if (!v) return '';
    v = v.toString();
    return v[0]?.toUpperCase() + v.slice(1);
  },
  'formatDate': (value: string) => value ? format(value, 'dd/MMM/yyyy') : '',
  // 'formatDate2': value => value ? format(value, 'dd.MMM.yyyy') : '',
  'formatDate3': (value: string) => formatDate(value, 'dd MMM yyyy HH:mm'),
  'formatDate4': (value: string) => formatDate(value, 'dd MMM yyyy'),
  'formatDate5': (value: string) => formatDate(value, 'dd MMMM yyyy HH:mm'),
  'formatTimeDate': (value: string) => formatDate(value, 'HH:mm dd MMM yyyy'),
  'formatMoney': (value: string | number) => numeral(value).format('0,0.00'),
  'formatMoneyNoFrac': (value: string | number) => numeral(value).format('0,0'),
  'duration': (value: string) => secondsToHumanReadable(value, locales[i18n.global.locale.value]),
  'currency': (value: string) => {
    switch (value ? value.toLowerCase() : value) {
    case 'rub':
      return '₽';
    case 'eur':
      return '€';
    case 'gpb':
      return '£';
    case 'btc':
      return '₿';
    case 'usd':
      return '$';
    case 'uah':
      return '₴';
    default:
      return value;
    }
  },
  'datetimeFilter': (val: string, type: string) => {
    let a = '';
    Config.allDimensions.forEach((v) => {
      if (v.name === type && _.has(v, 'formatOptions')) {
        a = `${format(
          val.toString().split(' ')[0] as string,
          v.formatOptions?.out as string,
          { locale: locales[i18n.global.locale.value] }
        )}
        ${_.isArray(val.toString().split(' ')) && val.toString().split(' ').length > 1
          ? val.toString().split(' ')[1]
          : ''
        }`;
      }
    });
    if (a === '') {
      a = val;
    }
    return a;
  },
  'numberAbbreviation': (value: string | number) => {
    const number = Number(value);
    if (Number.isNaN(number) || Math.abs(number) < 10000) {
      return value;
    }

    return numeral(number).format('0.[0]a', (num) => Math.sign(num) * Math.floor(Math.abs(num)));
  },
};

export type FiltersType = typeof filters;

export function useFilters() {
  return filters;
}

export default (App: App<Element>) => {
  App.config.globalProperties.$filters = filters;
};
